import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import './ListCard.css';

const ListCard = ({ colSize = "col-md-4", permissions, updatePermission, deletePermission,
  updateUrl, onDelete, icon, item, description = '', preTitle = '' }) => {

  return (
    <div className={`${colSize} mb-4`}>
      <div className="list-card">
        <div className="list-card-title">
          {preTitle} {item.name}
        </div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="list-card-icon-badge">
            <i className={icon}></i>
          </div>
          <div className="list-card-actions">
            {permissions.includes(updatePermission) ? (
              <Link to={updateUrl} className="list-card-action-btn edit" title="Edit">
                <FontAwesomeIcon icon={faEdit} />
              </Link>
            ) : null}
            {permissions.includes(deletePermission) ? (
              <span
                className="list-card-action-btn delete"
                title="Delete"
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you wish to delete this item?"
                    )
                  )
                    onDelete(item.id);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </span>
            ) : null}
          </div>
        </div>
        {description}
      </div>
    </div>
  );
};

export default ListCard;
